import { TestResolver } from "../../models";

export const additionsValueIsRequired: TestResolver = ({
  context,
  validationAdditional,
  value,
  errorMessage,
}) => {
  if (
    value !== null &&
    typeof value === "object" &&
    "value" in value &&
    "isCurrency" in value &&
    typeof value.value === "number" &&
    typeof value.isCurrency === "boolean"
  ) {
    return true;
  }

  return context.createError({ message: errorMessage, path: context.path });
};
